<template>
  <div class="map" :id="id"></div>
</template>

<script>

export default {
  props: {
    lat: String,
    long: String
  },

  data: () => ({
    latitute: 0,
    longitude: 0,
    id : 'map1'
  }),

  mounted () {
    this.latitute = parseFloat(this.lat)
    this.longitude = parseFloat(this.long)
    this.initGmap(this.latitute,this.longitude)
  },

  methods: {
    initGmap (lat, lng) {

      // var icon = {
      //   url: '/images/marker.png',
      //   size: new google.maps.Size(43, 57),
      //   scaledSize: new google.maps.Size(43, 57)
      // }

      // var curpoint = new google.maps.LatLng(lat, lng)

      // var data = new google.maps.Map(document.getElementById(this.id), {
      //   center: curpoint,
      //   zoom: 16,
      //   mapTypeId: 'roadmap'
      // })

      // var gmapmarker = new google.maps.Marker({
      //   position: curpoint,
      //   icon: icon,
      //   map: data,
      // })

      // return gmapmarker;

      const myLatLng = { lat: lat, lng: lng };
      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 16,
        center: myLatLng,
      });

      new google.maps.Marker({
        position: myLatLng,
        map : map
      });
    }
  }
};
</script>

<style lang="scss">
.map {
  height: 300px;
}
</style>